var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaskAlt = function SvgTaskAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80C46B",
    d: "M12 2c2.13 0 4.1.67 5.72 1.81l-1.44 1.44A7.9 7.9 0 0 0 12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8c0-.61-.08-1.21-.21-1.78l1.61-1.61c.38 1.06.6 2.2.6 3.39 0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2m10 3.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10z"
  })));
};
export default SvgTaskAlt;